import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './value.json';

const Value = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Value creation, worth, and economic principles vocabulary. B2/C1 level grammar, reading, and discussion exercises."
            level="B2"
            title="Value"
            image="/Images/value.webp"
            seoTitle="Free English Lesson Plans: Values"
            seoDescription="Value creation, worth, and economic principles vocabulary. B2/C1 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Value;


